import axios from 'axios';

export default {
  getChannel (second, order, page, hashtag, type) { // 채널 목록 조회 (time: 채널 새글 최신순 조회)
    return new Promise((resolve, reject) => {
      axios.get(`/v3/channel`, {
        params: {
          time: second,
          order,
          page,
          count: 20,
          hashtag,
          type
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  // getChannelCategory (second, order, page, hashtag) { // 채널 특수 목록 조회 (카테고리별 목록)
  //   return new Promise((resolve, reject) => {
  //     axios.get(`/v3/channel/category`, {
  //       params: {
  //         time: second,
  //         page,
  //         count: 20,
  //         hashtag
  //       }
  //     }).then((response) => {
  //       if (response.data) resolve(response.data);
  //       reject(response);
  //     }).catch(reject);
  //   });
  // },
  getChannelIdx (idx) {
    return new Promise((resolve, reject) => {
      axios.get(`/v3/channel/${idx}`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getChannelPost (channel_idx, second, order, page, hashtag) {
    return new Promise((resolve, reject) => {
      axios.get(`/v3/post`, {
        params: {
          channel_idx,
          time: second,
          order,
          page,
          count: 10,
          hashtag,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPost (formData) { // 채널 내부에 피드 글 생성
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post`, formData).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postChannelSubscribe (idx) { // 채널 구독 토글
    return new Promise((resolve, reject) => {
      axios.post(`/v3/channel/${idx}/subscribe`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  patchChannelIdx (idx, fields) {
    return new Promise((resolve, reject) => {
      axios.patch(`/v3/channel/${idx}`, fields).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  }
}
